import walletManager from '../../../_core/wallet-manager';
import { GET_ERC20_BALANCE } from '../../../constants';
import { createAsyncAction } from '../../actions';
import { walletAddressSelector } from '../selectors';

/**
 * Get balance of erc20 token, by default apply conversion wei -> eth
 * @param { string } erc20address
 * @param { number } customDecimals - for case when decimals value isn't equal to 18
 * @returns {Promise<{erc20address:string, balance:number}>}
 */
const getERC20Balance = createAsyncAction(GET_ERC20_BALANCE, function(erc20address, customDecimals = undefined) {
  return (dispatch, getState) => {
    const state = getState();

    /**
     * We use undefined for ability to use default value in walletManager method
     */
    const userAddress = walletAddressSelector(state) || undefined;

    return walletManager.getERC20Balance(erc20address, userAddress)
      .then(result => {
        let balance = result;
        // const decimals = getState().wallet.getIn(['tokens', 'all', erc20address, 'token_decimals']);
        // const balance =
        //   parseFloat(walletManager.fromWei(wei, EthereumConstants.UNITS[decimals] || 'ether').toString());
        /**
         * Some tokens gas different decimal value and it should be corrected (USDT has `6` decimals)
         * In protocol we use fromWei(value, 'ether') logic for convert all balances
         */
        if (customDecimals && typeof customDecimals === 'number' && customDecimals !== 18) {
          balance *= 10 ** (18 - customDecimals);
        }

        dispatch(this.success({ erc20address, balance }));
        return balance;
      })
      .catch(err => {
        dispatch(this.failed(err));
        return Promise.reject(err);
      });
  };
});

export default getERC20Balance;
